export default [
  {
    name: 'AssetRequirementsList',
    path: '/fixed-assets/requirements-list',
    component: () => import('@/views/fixedAssets/assetRequirementsList/AssetRequirementsList'),
    meta: {
      title: '资产需求清单'
    }
  },
  {
    name: 'AssetsRequirementsDetail',
    path: '/fixed-assets/requirements-list/detail',
    component: () => import('@/views/fixedAssets/assetRequirementsList/AssetRequirementsDetail'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/requirements-list',
      title: '需求申请单详情'
    }
  },
  {
    name: 'assetReceiveList',
    path: '/fixed-assets/receive-list',
    component: () => import('@/views/fixedAssets/assetReceiveList/assetReceiveList'),
    meta: {
      title: '资产领用单'
    }
  },
  {
    name: 'assetReceiveDetail',
    path: '/fixed-assets/receive-list/detail',
    component: () => import('@/views/fixedAssets/assetReceiveList/assetReceiveDetail'),
    meta: {
      parentAuth: '/fixed-assets/receive-list',
      notCache: true,
      title: '领用单详情'
    }
  },
  {
    name: 'assetReceiveForm',
    path: '/fixed-assets/receive-list/create',
    component: () => import('@/views/fixedAssets/assetReceiveList/assetReceiveForm'),
    meta: {
      parentAuth: '/fixed-assets/receive-list',
      title: '新增领用单'
    }
  },
  {
    name: 'AssetRequirementsForm',
    path: '/fixed-assets/requirements-list/asset-receive-form',
    component: () => import('@/views/fixedAssets/assetRequirementsList/AssetRequirementsForm'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/requirements-list',
      title: '下推领用单'
    }
  },
  {
    name: 'assetPurchasingList',
    path: '/fixed-assets/purchasing-list',
    component: () => import('@/views/fixedAssets/assetPurchasingList/assetPurchasingList'),
    meta: {
      title: '资产采购清单'
    }
  },
  {
    name: 'assetPurchasingDetail',
    path: '/fixed-assets/purchasing-list/detail',
    component: () => import('@/views/fixedAssets/assetPurchasingList/assetPurchasingDetail'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/purchasing-list',
      title: '采购申请单'
    }
  },
  {
    name: 'assetOrderList',
    path: '/fixed-assets/order-list',
    component: () => import('@/views/fixedAssets/assetOrderList/assetOrderList'),
    meta: {
      title: '资产采购订单'
    }
  },
  {
    name: 'assetOrderDetail',
    path: '/fixed-assets/order-list/detail',
    component: () => import('@/views/fixedAssets/assetOrderList/assetOrderDetail'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/order-list',
      title: '采购订单详情'
    }
  },
  {
    name: 'assetOrderForm',
    path: '/fixed-assets/order-list/create',
    component: () => import('@/views/fixedAssets/assetOrderList/assetOrderForm'),
    meta: {
      notCache: true,
      title: '新建采购订单',
      parentAuth: '/fixed-assets/order-list'
    }
  },
  {
    name: 'assetOrderForm2',
    path: '/fixed-assets/order-list/order-form',
    component: () => import('@/views/fixedAssets/assetOrderList/assetOrderForm'),
    meta: {
      notCache: true,
      title: '下推采购订单',
      parentAuth: '/fixed-assets/purchasing-list'
    }
  },
  {
    name: 'AssetInboundList',
    path: '/fixed-assets/inbound-list',
    component: () => import('@/views/fixedAssets/assetInboundList/AssetInboundList'),
    meta: {
      title: '资产入库单'
    }
  },
  {
    name: 'assetInboundDetail',
    path: '/fixed-assets/inbound-list/detail',
    component: () => import('@/views/fixedAssets/assetInboundList/assetInboundDetail'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/inbound-list',
      title: '入库单详情'
    }
  },
  {
    name: 'AssetInboundForm',
    path: '/fixed-assets/inbound-list/create',
    component: () => import('@/views/fixedAssets/assetInboundList/AssetInboundForm'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/inbound-list',
      title: '新建入库单'
    }
  },
  {
    name: 'AssetInboundForm2',
    path: '/fixed-assets/inbound-list/inbound-form',
    component: () => import('@/views/fixedAssets/assetInboundList/AssetInboundForm'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/order-list',
      title: '下推入库单'
    }
  },
  {
    name: 'assetChangeList',
    path: '/fixed-assets/change-list',
    component: () => import('@/views/fixedAssets/assetChangeList/assetChangeList'),
    meta: {
      title: '资产变更单'
    }
  },
  {
    name: 'assetChangeDetail',
    path: '/fixed-assets/change-list/detail',
    component: () => import('@/views/fixedAssets/assetChangeList/assetChangeDetail'),
    meta: {
      notCache: true,
      parentAuth: '/fixed-assets/change-list',
      title: '变更单详情'
    }
  },
  {
    name: 'AssetCardsList',
    path: '/fixed-assets/card-list',
    component: () => import('@/views/fixedAssets/assetCardsList/AssetCardsList'),
    meta: {
      title: '资产卡片库'
    }
  },
  {
    name: 'assetCardDetail',
    path: '/fixed-assets/card-list/detail',
    component: () => import('@/views/fixedAssets/assetCardsList/assetCardDetail'),
    meta: {
      title: '资产卡片详情',
      parentAuth: '/fixed-assets/card-list'
    }
  },
  {
    name: 'assetCardForm',
    path: '/fixed-assets/card-list/create',
    component: () => import('@/views/fixedAssets/assetCardsList/assetCardForm'),
    meta: {
      title: '新建资产卡片',
      parentAuth: '/fixed-assets/card-list',
    }
  },
  {
    name: 'assetCardForm2',
    path: '/fixed-assets/card-list/update',
    component: () => import('@/views/fixedAssets/assetCardsList/assetCardForm'),
    meta: {
      title: '编辑资产卡片',
      parentAuth: '/fixed-assets/card-list',
    }
  },
  // 非资产卡片
  {
    name: 'nonAssetCardsList',
    path: '/fixed-assets/non-card-list',
    component: () => import('@/views/fixedAssets/nonAssetCards/AssetCardsList'),
    meta: {
      title: '非资产卡片库'
    }
  },
  {
    name: 'nonAssetCardDetail',
    path: '/fixed-assets/non-card-list/detail',
    component: () => import('@/views/fixedAssets/nonAssetCards/assetCardDetail'),
    meta: {
      title: '非资产卡片详情',
      parentAuth: '/fixed-assets/card-list',
    }
  },
  {
    name: 'nonAssetCardForm2',
    path: '/fixed-assets/non-card-list/update',
    component: () => import('@/views/fixedAssets/nonAssetCards/assetCardForm'),
    meta: {
      title: '编辑非资产卡片',
      parentAuth: '/fixed-assets/card-list',
    }
  },
  {
    name: 'AssetCategoryList',
    path: '/fixed-assets/manage-category',
    component: () => import('@/views/fixedAssets/assetCategoryList/AssetCategoryList'),
    meta: {
      title: '资产类型管理'
    }
  },
  {
    name: 'assetInventory',
    path: '/fixed-assets/Inventory',
    component: () => import('@/views/fixedAssets/assetInventory/index.vue'),
    meta: {
      title: '资产盘点'
    }
  },
  {
    name: 'addAssetInventory',
    path: '/fixed-assets/add-inventory',
    component: () => import('@/views/fixedAssets/assetInventory/inventtoryForm.vue'),
    meta: {
      title: '新增盘点活动',
      parentAuth: '/fixed-assets/Inventory',
      notCache: true
    }
  },
  {
    name: 'assetInventoryDetail',
    path: '/fixed-assets/inventory-detail/:inventoryId',
    component: () => import('@/views/fixedAssets/assetInventory/inventtoryForm.vue'),
    meta: {
      title: '盘点活动详情',
      parentAuth: '/fixed-assets/Inventory',
      notCache: true
    },
    props: true,
  },
  {
    name: 'assetHandyTray',
    path: '/fixed-assets/assetHandyTray',
    component: () => import('@/views/fixedAssets/assetHandyTray/index.vue'),
    meta: {
      title: '随手盘记录',
      parentAuth: '/fixed-assets/Inventory',
      notCache: true
    }
  },
  {
    name: 'resignationAssetManagement',
    path: '/fixed-assets/resignationAssetManagement',
    component: () => import('@/views/fixedAssets/resignationAssetManagement/index.vue'),
    meta: {
      title: '离职资产管理',
    }
  },
  {
    name: 'resignationAssetManagementDetail',
    path: '/fixed-assets/resignationAssetManagement/detail/:id',
    component: () => import('@/views/fixedAssets/resignationAssetManagement/detail.vue'),
    meta: {
      title: '离职资产详情',
      parentAuth: '/fixed-assets/resignationAssetManagement',
      notCache: true
    }
  },
  {
    name: 'assetCompensationManagement',
    path: '/fixed-assets/assetCompensationManagement',
    component: () => import('@/views/fixedAssets/assetCompensationManagement/index.vue'),
    meta: {
      title: '资产赔偿管理',
    }
  },
  {
    name: 'assetCompensationBatchLoss',
    path: '/fixed-assets/assetCompensationManagement/batchLoss',
    component: () => import('@/views/fixedAssets/assetCompensationManagement/batchLoss.vue'),
    meta: {
      parentAuth: '/fixed-assets/assetCompensationManagement',
      title: '批量定损'
    }
  },
  {
    name: 'assetCompensationNoCompensation',
    path: '/fixed-assets/assetCompensationManagement/noCompensation',
    component: () => import('@/views/fixedAssets/assetCompensationManagement/noCompensation.vue'),
    meta: {
      parentAuth: '/fixed-assets/assetCompensationManagement',
      title: '无需赔偿'
    }
  },
  {
    name: 'assetCompensationManagementDetail',
    path: '/fixed-assets/assetCompensationManagement/detail/:id',
    component: () => import('@/views/fixedAssets/assetCompensationManagement/detail.vue'),
    meta: {
      title: '资产赔偿详情',
      parentAuth: '/fixed-assets/assetCompensationManagement',
      notCache: true
    }
  },
]
